import { Injectable } from '@angular/core';
import { LineChartModule } from '@swimlane/ngx-charts';
import { Observable, BehaviorSubject, Subject, ReplaySubject, } from 'rxjs';
// import { Order, OrderLine } from '../../models/order.model';
import { map, scan, startWith, merge, filter } from 'rxjs/operators';
import { Order, OrderLine } from 'src/app/theBookableServices/models/order.model';
import { Booking } from '../models/booking.model';
// import { OrderLine } from '../models/order';
import { OrdersService } from './orders.service';
// import { Booking } from 'src/app/models/booking.model';

@Injectable({
  providedIn: 'root'
})
export class BasketService {

  public orderLinesRef = new BehaviorSubject<any>([]);
  public bookingRef = new BehaviorSubject<any>([]);
  // public orderLines = new Subject<OrderLine>();
  public orderLines: OrderLine[] = [];

  constructor(
    private ordersService: OrdersService
  ) {

    this.orderLinesRef
      .subscribe((orderLine) => {

        console.warn('BasketService orderLine', orderLine);
      });

    this.orderLinesRef.next(this.orderLines);

  }

  sendCurrentBooking(booking: Booking){
    this.bookingRef.next(booking);
  }

  addOrderLine(orderLine: any) {

    // If duplicate order id, increment quantity

    if (this.orderLines.filter(e => e.id === orderLine.id).length > 0) {
      this.orderLines.forEach((e) => {
        if (e.id === orderLine.id) {
          e.quantity = e.quantity + 1;
        }
      });
    } else {
      this.orderLines.push(orderLine);
    }

    console.log('this.orderLines', this.orderLines);
    this.orderLinesRef.next(this.orderLines);

  }

  deleteOrderLine(orderLine: any) {

    let indexToDelete = -1;

    this.orderLines.forEach((ol: OrderLine, i) => {

      if (ol.id === orderLine.id) {
        indexToDelete = i;
      }
    });

    if (indexToDelete !== -1) {
      this.orderLines.splice(indexToDelete, 1);
      this.orderLinesRef.next(this.orderLines);
    }

  }

  incQuantity(orderLineArg: any) {

    if (this.orderLines.filter(e => e.id === orderLineArg.id).length > 0) {

      this.orderLines.map((orderLine) => {
        if (orderLine.id === orderLineArg.id) {
          orderLine.quantity = orderLine.quantity + 1;
        }

        this.orderLinesRef.next(this.orderLines);
        return;
      });
      // this.orderLines.forEach((orderLine) => {
      //   if (orderLine.id === orderLine.id) {

      //     orderLine = Object.assign({}, orderLine);

      //     // let temp = orderLine;
      //     // temp = orderLine.quantity;
      //     console.warn("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee" , orderLine)
      //     // e.quantity = Object.assign({}, e.quantity, { quantity: e.quantity + 1 });


      //     // let temp = e.quantity;
      //     // temp = temp + 1;
      //     // e.quantity = temp
      //     orderLine.quantity = orderLine.quantity + 1;
      //   }
      // });
    }

    // console.log('this.orderLines', this.orderLines);
    // this.orderLinesRef.next(this.orderLines);

  }

  decQuantity(orderLine: any) {

    if (this.orderLines.filter(e => e.id === orderLine.id).length > 0) {
      this.orderLines.forEach((e) => {
        if (e.id === orderLine.id && e.quantity > 1) {
          e.quantity = e.quantity - 1;
        }
      });
    }


    this.orderLinesRef.next(this.orderLines);

  }

  getBasketOrderLine() {

    // return this.orderLines.asObservable();
    return this.orderLines;

  }

  clearOrderLines(){

    console.warn('this.orderLines.length', this.orderLines.length);

    const orderCount = this.orderLines.length - 1;
    for (let i = orderCount; i >= 0; i--) {
      this.orderLines.splice(i, 1);
    }

    this.orderLinesRef.next(this.orderLines);
    console.warn('this.orderLines.length', this.orderLines.length);
  }

  addOrder(companyId: any, siteId: any, userId: any, table: any, createDate: any, bookingId: any, status?: any, paymentStatus?: any, currentOrder?: Order) {

    const order = Object.assign(Order);

    console.log('kjb addOrder currentOrder', currentOrder);

    const orderLinesTemp: any[] = [];
    if (currentOrder != undefined){

      currentOrder.orderLines.forEach((line: any) => {

        // public id: string,
        // public heading: string,
        // public detail: string,
        // public cost: number,
        // public prodId: string,
        // public quantity: number,
        // public image: any,

        const l = {
          id: line.id,
          heading: line.heading,
          detail: line.detail,
          cost: line.cost,
          // prodId : line.prodId,
          quantity: line.quantity,
          image: {...line.image},
          kCal: line.kCal,
          salesStyle: line.salesStyle,
          status: null
        };

        orderLinesTemp.push(l);
      });

    }

    console.log('kjb addOrder orderLinesTemp', orderLinesTemp);

    order.createDate = createDate;
    order.companyId = companyId;
    order.siteId = siteId;
    order.bookingId = bookingId;
    order.userId = userId.uid;
    order.table = table;
    order.orderLines = orderLinesTemp;
    // if (currentOrder != undefined){
    //   order.orderLines = currentOrder.orderLines;
    // }

    order.status = (status === undefined) ? 'open' : status;
    order.paymentStatus = paymentStatus;

    order.discount = currentOrder?.discount;
    order.deliveryCost = currentOrder?.deliveryCost;

    const o = Object.assign({}, {
      time: new Date(),
      order: Object.assign({}, order)
    });

    console.log('kjb addOrder o', o);
    this.ordersService.addOrder(o);

    // this.ordersService.addOrder({...order});


    console.warn('this.orderLines.length', this.orderLines.length);

    const orderCount = this.orderLines.length - 1;
    for (let i = orderCount; i >= 0; i--) {
      this.orderLines.splice(i, 1);
    }

    this.orderLinesRef.next(this.orderLines);
    console.warn('this.orderLines.length', this.orderLines.length);

    // setTimeout(() => {
    //   console.warn('this.orderLines.length', this.orderLines.length);

    //   const orderCount = this.orderLines.length - 1;
    //   for (let i = orderCount; i >= 0; i--) {
    //     this.orderLines.splice(i, 1);
    //   }

    //   this.orderLinesRef.next(this.orderLines);
    //   console.warn('this.orderLines.length', this.orderLines.length);
    // }, 3000);

    // console.log('this.orderLines.length', this.orderLines.length);

    // console.warn('the order passed' , order);

    // let theOrderLines = [];
    // this.orderLines.forEach((orderLine: OrderLine) => {
    //   theOrderLines.push(orderLine);
    // })

    // console.log('theOrderLines' , theOrderLines);
    // this.ordersService.addOrder(order)

    // const orderCount = this.orderLines.length - 1;
    // for (let i = orderCount; i >= 0; i--) {
    //   this.orderLines.splice(i, 1);
    // }
    // this.orderLinesRef.next(this.orderLines);
    // console.log('this.orderLines.length', this.orderLines.length);



    // this.ordersService.addOrder(o).then(() => {

    //   console.log('clear order lilnes');
    //   console.log('this.orderLines.length', this.orderLines.length);

    //   const orderCount = this.orderLines.length - 1;
    //   for (let i = orderCount; i >= 0; i--) {
    //     this.orderLines.splice(i, 1);
    //   }
    //   this.orderLinesRef.next(this.orderLines);
    //   console.log('this.orderLines.length', this.orderLines.length);

    // });

  }

  // getAllcompanies(): Observable<OrderLine[]> {
  //   return this.orderLines;
  // }
}
